<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			goodscode: {
				default: () => {
					return null
				}
			},
			warehousewlnid: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '库存信息',
				modal_width: 600,
				modal_height: 500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'storage_name',
						title: '仓库名称'
					},
					{
						field: 'quantity',
						title: '实际库存',
					},
					{
						field: 'availableSize',
						title: '可用库存',
					},
					{
						field: 'underway',
						title: '在途',
					},
					{
						field: 'islocalwarehouse',
						title: '本次采买仓库',
						formatter({cellValue}){
							return cellValue?'是':''
						}
					}
				]
				gridOptions.formConfig = false
			},
			modal_init() {
				this.modal_title = '库存信息' + '【' + this.goodscode + '】'
			},
			list() {
				return new Promise((resolve) => {
					this.$api.goods.getInventory(0, {
						goodscode: this.goodscode
					}).then((res) => {
						res.inventory.forEach((item) => {
							item.islocalwarehouse = false
							if (item.storageID == this.warehousewlnid) {
								item.islocalwarehouse = true
							}
						})
						//console.log(res)
						resolve({
							list: res.inventory
						})
					})

				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>